import { createSelector } from 'reselect';
import { reduxKey } from './constants';
function getSlice(state) {
    if (!state[reduxKey]) {
        return {};
    }
    return state[reduxKey];
}
export const getCurrentHeadState = createSelector(getSlice, (slice)=>{
    return slice.headState;
});
export const getHeadLinks = createSelector(getCurrentHeadState, (state)=>{
    return state === null || state === void 0 ? void 0 : state.link;
});
export const getHeadMeta = createSelector(getCurrentHeadState, (state)=>{
    return state === null || state === void 0 ? void 0 : state.meta;
});
export const getHeadScript = createSelector(getCurrentHeadState, (state)=>{
    return state === null || state === void 0 ? void 0 : state.script;
});
export const getHeadStyle = createSelector(getCurrentHeadState, (state)=>{
    return state === null || state === void 0 ? void 0 : state.style;
});
export const getTitle = createSelector(getCurrentHeadState, (state)=>{
    return state === null || state === void 0 ? void 0 : state.title;
});
